<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        :key="identify"
        :ref="identify"
        :show-more-scheme="true"
        :show-simple="showSimple"
        :col-settings="{span:12}"
        :expand-adv="true"
        :search-item-code="searchItemCode"
        :config-module="configModule"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        :custom-sim-query-placeholder="simQueryPlaceholder"
        @advSearchItemCallBack="fetchData"
        @simSearchItemCallBack="fetchDataByKeyWord"
        @advToggle="scrollCallback"
      >
        <template slot="operations">
          <slot name="operations" />
        </template>
        <template slot="searchAreaHeader">
          <slot name="searchAreaHeader" />
        </template>
      </search-item>
      <div class="section grid-wrapper" style="min-height: 300px">
        <cargo-ag-grid
          :config-module="gridConfigModule"
          :grid-params.sync="jobGrid.gridParams"
          :grid-options="jobGrid.gridOptions"
          :column-defs="columnDefs"
          :row-data="jobGrid.rowData"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper">
        <div style="display: flex;justify-content: flex-end;flex-wrap: wrap">
          <charge-currency-total-group
            v-if="reCalc"
            :amount-to-currency="localCurrency"
            data-field="chargeAmount"
            currency-field="chargeCurrency"
            rate-field="chargeRate"
            ar-field="chargeReceivable"
            type="auto"
            :arap-group="false"
            arap-order="ap"
            :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"
          />
          <charge-count-group
            v-if="reCalc && showChargeCount"
            :new-by-job="newByJob"
            :selected-count="totalAmountToCurrencyChargeGrid.selectedCount"
            :data-provider="totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider"
            :display-and-count-field-list="totalAmountToCurrencyChargeGrid.displayAndCountFieldList"
            :basic-currency="localCurrency"
            :always-show="alwaysShow"
          />
        </div>
        <cargo-pagination
          :config-module="gridConfigModule"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { Once } from '@/utils/commonUtil'
import { queryJobPageableFastForPayApply } from '@/api/clearing/billPayment.js'
import lodash from 'lodash'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import { formatNumberToThousands } from '@/utils'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'QueryJobFastForPayApply',
  components: { searchItem, ChargeCountGroup, chargeCurrencyTotalGroup },
  props: {
    showSimple: { type: Boolean, default: true }, // 是否显示简单查询
    identify: { type: String, required: true, default: 'queryJob' }, // ID
    viewSource: { type: String, required: true, default: '' }, // 引用页面
    configModule: { type: String, required: true, default: '' }, // 高级查询条件
    gridConfigModule: { type: String, required: true, default: '' }, // 列表设置
    jobStateParam: { type: String, default: '' },
    chargeStateParam: { type: String, default: '' },
    confirmStateParam: { type: String, default: '' },
    confirmState: { type: Number, default: -1 }, // 确认状态
    hasBillPayment: { type: Number, default: -1 }, // 是否关联付款申请
    isShowWriteOff: { type: Boolean, default: true }, // 是否显示已核销的费用
    hasInvoice: { type: Number, default: -1 }, // 是否开票
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showInvoiceState: { type: Boolean, default: true }, // 显示开票状态
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'rate' }, // 汇率字段
    type: { type: String, default: 'revenueAbs', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arApGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    isControlled: { type: Boolean, default: false }, // 是否有应付受控费用权限
    isCostControlled: { type: Boolean, default: false }, // 是否有应收受控费用权限
    newByJob: { type: Number, default: 1 }, // 用于财务审核 和 付款申请 1 //1 付款申请 业务; 2 付款申请 费用; 3 财务审核
    hidePop: { type: Boolean, default: false }, // 根据弹框展示/隐藏
    alwaysShow: { type: Boolean, default: true },
    internalCharge: { type: Boolean, default: false } // 内结
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '按费用查询',
      simQueryPlaceholder: this.$t('Clearing.QuickSearchBusinessNumber'),
      jobGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowSelected: this.onRowSelected,
          onRowClicked: this.onRowClicked
        },
        rowData: []
      },
      searchConditions: {
        total: 0, // 按费用
        pageNum: 1, // 按费用
        pageSize: 20,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: [],
        groups: ['job.UUID', 'charge.ACCOUNT_ID', 'charge.CURRENCY'], // 分组条件
        invoiceReceiveChargeState: '', // InvoiceReceiveChargeState, 开票-应收费用-费用状态查询(发票)
        invoicePayChargeState: '', // InvoicePayChargeState, 开票-应付费用-费用状态查询(发票)
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [] // 确认状态
      },
      initSearchConditions: {
        total: 0, // 按费用
        pageNum: 1, // 按费用
        pageSize: 20,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: [],
        groups: ['job.UUID'], // 分组条件
        invoiceReceiveChargeState: '', // InvoiceReceiveChargeState, 开票-应收费用-费用状态查询(发票)
        invoicePayChargeState: '', // InvoicePayChargeState, 开票-应付费用-费用状态查询(发票)
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [] // 确认状态
      },
      totalAmountToCurrencyChargeGrid: { // 右下角合计组件相关参数
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [],
        chargeCountGroupDataProvider: []
      },
      once: new Once(this),
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      queryOfficeId: 0 // 记录查询时的分公司Id
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobJobNo' },
              routeTitle: this.$t('Clearing.FinancialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {}
            }
          }},
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
        { headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.carrierId'), field: 'jobCarrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.businessType'), field: 'jobLob', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          } },
        { headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVessel', width: 200 },
        { headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          } },
        { headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          } },
        { headerName: this.$t('Payment.operation'), field: 'jobOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.sales'), field: 'jobSales', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          } },
        { headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          } },
        { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 200 },
        { headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmounts', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(params.value, 2)
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200 },
        { headerName: this.$t('Payment.atd'), field: 'jobAtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.ata'), field: 'jobAta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ProjectName'),
          field: 'jobProjectName',
          colId: 'jobProjectName',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BookingAgent'),
          field: 'jobBookingAgent',
          colId: 'jobBookingAgent',
          hide: true,
          cellRenderer: (params) => {
            if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
              return ''
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          },
          initialWidth: 200
        },
        {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'exChangeAgent',
          colId: 'exChangeAgent',
          hide: true,
          cellRenderer: (params) => {
            if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
              return params.data.jobBookingAgent ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobBookingAgent, 'auto_1') : ''
            }
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          },
          initialWidth: 200
        },
        {
          headerName: this.$t('SeaExport.CategoryOfGoods'),
          field: 'cargoCode',
          colId: 'cargoCode',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
          },
          hide: true,
          width: 150
        }
      ]
    }
  },
  watch: {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {
  },
  mounted() {
    this.scrollCallback()
    document.querySelector('.queryJob').addEventListener('scroll', this.scrollCallback)
  },
  methods: {
    // 配置参数
    async initConfig() {
      // 业务状态
      this.searchConditions.jobStates = await LoadDefaultQueryParam.getConfigQueryParam(this.jobStateParam, SystemConstants.JOB_STATES)
      // 费用确认状态
      this.searchConditions.confirmStates = await LoadDefaultQueryParam.getConfigQueryParam(this.confirmStateParam, ChargeConstants.CONFIRM_STATES)
      // 费用状态
      this.searchConditions.chargeStates = await LoadDefaultQueryParam.getConfigQueryParam(this.chargeStateParam, ChargeConstants.CHARGE_STATES)
    },
    // 查询
    async fetchData(conditions, simpleTriggerMode = false) {
      await this.initConfig()
      this.searchConditions.pageNumChargeGrid = 1
      const finallyConditions = []
      const advConditions = lodash.cloneDeep(conditions)
      // 红冲状态
      const condition = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
      finallyConditions.push(condition.formatObj2Json())
      // 业务状态
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption('job.JOB_STATE', conditions)) {
        const jobStates = LoadDefaultQueryParam.convertCommonStateToInt(this.searchConditions.jobStates)
        const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 费用状态
      if (this.searchConditions.chargeStates && this.searchConditions.chargeStates.length > 0 && !LoadDefaultQueryParam.isSelectOption('charge.CHARGE_STATE', conditions)) {
        const chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(this.searchConditions.chargeStates)
        const condition = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 费用确认状态
      if (this.searchConditions.confirmStates && this.searchConditions.confirmStates.length > 0 && !LoadDefaultQueryParam.isSelectOption('charge.CONFIRM_STATE', conditions)) {
        const confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(this.searchConditions.confirmStates)
        const condition = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', confirmStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否做过付款申请
      if (this.hasBillPayment !== -1) {
        const operator = this.hasBillPayment === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILL_PAYMENT_UUID', null, operator)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 应收/应付
      if (this.isAr !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', this.isAr === 1, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 是否显示  0 不勾选 1勾选已核销
      if (this.isShowWriteOff) {
        const condition = new AdvancedSearchOption(null, 'charge.PAID_OFF', false, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 内结
      if (this.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      if (!this.showControlledCharge) {
        this.getControlledConditions(finallyConditions)
      }
      finallyConditions.push(...advConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      console.log('this.searchConditions.snapshotConditions', this.searchConditions.snapshotConditions)
      this.toQueryJobList()
    },
    // 获取charge控制条件
    getControlledConditions(conditions) {
      // 是否有应付受控费用权限
      const isControlled = this.$checkPermission(['button_Charge_controlled'])
      // 是否有应收受控费用权限
      const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
      let value = 0
      if (!isControlled && !isCostControlled) {
        value = 1
      } else if (!isControlled) {
        value = 2
      } else if (!isCostControlled) {
        value = 3
      }
      if (value !== 0) {
        conditions.push(new AdvancedSearchOption(null, 'cIsControlled', value).formatObj2Json())
      }
    },
    // 快捷检索
    fetchDataByKeyWord(keyWord) {
      if (!StrUtils.isEmpty(keyWord)) {
        this.searchConditions.pageNumChargeGrid = 1
        const conditions = []
        const option = new AdvancedSearchOption(null, 'job.JOB_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        if (conditions.length > 0) {
          this.fetchData(conditions, true)
        }
      }
    },
    // 分页触发查询
    fetchDataByPage(param) {
      this.toQueryJobList()
    },
    toQueryJobList() {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires, groups, pageNum, pageSize } = this.searchConditions
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, groups, 'requestSource': this.viewSource }
      this.loading = getLoading()
      queryJobPageableFastForPayApply(requestBody).then(res => {
        this.jobGrid.rowData = lodash.cloneDeep(res.data.list)
        this.searchConditions.total = Number(res.data.total)
        //
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.getCharge(this.jobGrid.rowData)
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(this.jobGrid.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }).finally(() => {
        this.loading.close()
      })
    },
    //
    initCustomSearchItems() {
      const defaultSearchFields = []
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_businessStatus'
        searchField.itemName = 'job.JOB_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.jobStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.searchConditions.chargeStates && this.searchConditions.chargeStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_feeStatus'
        searchField.itemName = 'charge.CHARGE_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.chargeStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.searchConditions.confirmStates && this.searchConditions.confirmStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.defaultValue = []
        searchField.itemLabel = 'Billing.billingCharge_confirmStatus'
        searchField.itemName = 'charge.CONFIRM_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.confirmStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (defaultSearchFields && defaultSearchFields.length > 0) {
        this.customSearchItems = defaultSearchFields
      }
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(event) {
      console.log('toRefreshSelectedCountChargeGrid', event)
      this.filterChange()
      // this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
    },
    filterChange() {
      this.selections = getGridSelected(this.jobGrid.gridOptions)
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.jobGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.jobGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.jobGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.getCharge(selections)
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = selections.length
      } else if (arg == 1) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.getCharge(selections)
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.getCharge(this.jobGrid.rowData)
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(this.jobGrid.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        this.templateSelectorDialog.cxt = this.billingGrid.rowData.find(item => item.uuid === value)
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(`没有找到对应的打印模板`)
      }
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.queryJob')
        const footer = document.getElementById('footer-wrapper')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    getSelections() { // 获取勾选的项目
      return getGridSelected(this.jobGrid.gridOptions)
    },
    getConditions() { // 获取查询条件
      return this.searchConditions.snapshotConditions
    },
    // 重置相关属性
    reSetProperties() {
      this.jobGrid.rowData = []
      // 处理pageSize被本地化保存后不需要重置
      const pageSize = this.searchConditions.pageSize
      this.initSearchConditions.pageSize = pageSize

      this.searchConditions = this.initSearchConditions
      this.totalAmountToCurrencyChargeGrid.dataProvider = []
      this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = []
      this.totalAmountToCurrencyChargeGrid.selectedCount = 0
    },
    // 获取业务中的费用集合
    getCharge(jobs = []) {
      let charges = []
      if (jobs && jobs.length > 0) {
        for (const job of jobs) {
          if (job.charges && job.charges.length > 0) {
            charges = charges.concat(job.charges.filter(charge => this.isAr ? true : !charge.chargeReceivable))
          }
        }
      }
      return charges
    },
    // 重新组装合计弹出框数据源
    getChargeCountGroupDataProvider(rowData = []) {
      const list = []
      if (rowData && rowData.length > 0) {
        if (rowData && rowData.length > 0) {
          for (const job of rowData) {
            if (job.charges && job.charges.length > 0) {
              for (const charge of job.charges) {
                const map = {
                  charge_currency: charge.chargeCurrency,
                  charge_receivable: charge.chargeReceivable,
                  charge_exchangeRate: charge.chargeExchangeRate,
                  charge_amount: charge.chargeReceivable ? charge.chargeAmount * -1 : charge.chargeAmount
                }
                if (this.isAr || (!this.isAr && !charge.chargeReceivable)) {
                  list.push(map)
                }
              }
            }
          }
        }
      }
      return list
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
<style lang="scss">
.queryJob{
  #footer-wrapper {
  .fixedBottom {
    position: relative;
    bottom: 0;
    right: 15px;
    background: #fff;
  }
}
}

</style>
